import { Component, EventEmitter, Input, OnInit, Output, forwardRef } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { DebtorDocumentTypeV2, Template } from 'src/app/_models';
import { DebtorDocumentNumberType } from '../../constans/debtorDocumentType.constans';

@Component({
  selector: 'app-custom-country-phone-select',
  templateUrl: './custom-country-phone-select.component.html',
  styleUrls: ['./custom-country-phone-select.component.css'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => CustomCountryPhoneSelectComponent),
      multi: true
    }
  ]
})
export class CustomCountryPhoneSelectComponent implements ControlValueAccessor {

  @Input() options: DebtorDocumentTypeV2[] = [];
  @Input() placeholder: string = "";
  @Output() selectedOption = new EventEmitter<string>();
  @Input() version: 'V1' | 'V2' = 'V1';
  @Input() designVersion: 'V1' | 'V2' = 'V1';

  private onChange: (value: any) => void = () => { };
  private onTouch: () => void = () => { };

  isOpen = false;
  selectedValue: DebtorDocumentTypeV2;

  toggleDropdown() {
    this.isOpen = !this.isOpen;
  }

  selectOption(option: DebtorDocumentTypeV2) {
    let valueChanged: string;

    this.selectedValue = option;
    valueChanged = option.id;

    this.isOpen = false;
    this.onChange(valueChanged);
    this.onTouch();
    this.selectedOption.emit(valueChanged);
  }

  writeValue(id: DebtorDocumentTypeV2['id']): void {
    this.selectedValue = this.options.find(el => id === el.id);
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouch = fn;
  }

  setDisabledState(isDisabled: boolean): void { }
}
